import React from 'react';
// Components
import { Link } from 'gatsby';
import { useIntl } from 'react-intl';
import { Image } from '@unpic/react';
import { Carousel, Card } from '@printdeal/ui-library';
// types
import clsx from 'clsx';
import {
  CategoriesProps,
  CategoryCardImageProps,
} from '../../types/category/category';
// Helpers
import { dispatchDataLayerEventOnClick } from '../../helpers/dataLayerHelpers/CategoryPageDataLayerHelper';

interface CardGalleryProps {
  categories: CategoriesProps[];
  cardImage?: CategoryCardImageProps;
}

const messages = {
  prev: {
    id: 'general.pagination.button.previous',
    defaultMessage: 'Previous',
  },
  next: { id: 'general.pagination.button.previous', defaultMessage: 'Next' },
};

export const CategoryCardGallery = ({
  categories,
  cardImage = undefined,
}: CardGalleryProps) => {
  const intl = useIntl();

  const clickHandlerGA = (index: number, categoryName?: string) =>
    dispatchDataLayerEventOnClick({
      eventCategory: 'subcategory_navigation',
      eventAction: 'productTile',
      eventLabel: `${categoryName}(position: ${index + 1})`,
    });

  return (
    <Carousel
      prevButton={(
        <Carousel.Button
          variant="prev"
          screenReaderLabel={intl.formatMessage(messages.prev)}
          onClick={() =>
            dispatchDataLayerEventOnClick({
              eventCategory: 'subcategory_navigation',
              eventAction: 'navigation_arrow',
              eventLabel: 'previous',
            })}
        />
        )}
      nextButton={(
        <Carousel.Button
          variant="next"
          screenReaderLabel={intl.formatMessage(messages.next)}
          onClick={() =>
            dispatchDataLayerEventOnClick({
              eventCategory: 'subcategory_navigation',
              eventAction: 'navigation_arrow',
              eventLabel: 'next',
            })}
        />
        )}
    >
      {categories.map((category, index) => {
        const imageOfFirstPDP = cardImage?.categories?.[index]?.products?.[0]?.featuredImage;
        const imageOfFirstPDPOfFirstPLP = cardImage?.categories?.[index]?.products?.[0]?.products?.[0]?.featuredImage;

        const categoryImage = imageOfFirstPDP || imageOfFirstPDPOfFirstPLP;
        return (
          <Carousel.Item key={category.id}>
            <Card
              data-cy="subCategoryCarousalCard"
              variant="horizontal"
              className="pd-min-w-[17rem]"
              size="sm"
              image={
                  categoryImage?.url ? (
                    <Image
                      src={categoryImage.url}
                      alt={category.categoryName}
                      width={80}
                      height={80}
                      layout="fixed"
                      priority={index < 6}
                    />
                  ) : undefined
                }
              title={<span className={clsx(!categoryImage?.url && 'pd-ml-4')}>{category.categoryName}</span>}
              link={(
                <Link
                  to={category.path}
                  onClick={() => clickHandlerGA(index, category.categoryName)}
                />
                )}
            />
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
};
